import { AppLoading } from '@/components/AppLoading'
import { useAuth } from '@/context/AuthContext'
import { InsuranceParamsProvider, useInsuranceParams } from '@/context/InsuranceParamsProvider'
import { PoleasClientDisabled } from '@/pages/poleas/wizard/poleasClientDisabled'
import axios from 'axios'
import apiClient from 'brokertslib/src/Utils/apiClient'
import { useEffect, useState } from 'react'
import { Outlet } from 'react-router'
import { PoleasHeader } from './components/PoleasHeader'

export const PoleasAuthLayout = () => {
  const { user, isLoading, isLoggingOut, logout } = useAuth()

  // Logout if not logged
  useEffect(() => {
    if (!isLoading && !isLoggingOut && !user?.logged) {
      logout()
    }
  }, [isLoading, isLoggingOut, user])

  if (isLoading || isLoggingOut) return <AppLoading />

  return (
    <InsuranceParamsProvider>
      <PoleasAuthLayoutContent />
    </InsuranceParamsProvider>
  )
}

const PoleasAuthLayoutContent = () => {
  const { insuranceParams } = useInsuranceParams()
  const [isLocked, setIsLocked] = useState(false)

  useEffect(() => {
    const handleLockedError = (error: any) => {
      if (
        error.response?.status === 403 &&
        JSON.stringify(error.response?.data).includes('LOCKED')
      ) {
        setIsLocked(true)
      }
      return Promise.reject(error)
    }

    const apiClientInterceptor = apiClient.interceptors.response.use(r => r, handleLockedError)
    const axiosInterceptor = axios.interceptors.response.use(r => r, handleLockedError)

    return () => {
      apiClient.interceptors.response.eject(apiClientInterceptor)
      axios.interceptors.response.eject(axiosInterceptor)
    }
  }, [])


  if (insuranceParams?.generalParams.clientDisabled || isLocked)
    return <PoleasClientDisabled />

  return (
    <>
      <PoleasHeader />

      <Outlet />
    </>
  )
}
